<template>
    <div class="qualify-sidebar-input-item">
        <div class="vertical-input-container" v-if="isVertical">
            <slot></slot>
        </div>
        <template v-else>
            <slot></slot>
        </template>
        <span class="input-suffix">
            <template v-if="suffix">
                {{ suffix }}
            </template>
        </span>
        <span class="check-badge" :class="{'active': isFilled}"></span>
    </div>
</template>

<script>
    export default {
        name: 'QualifySidebarInputItem',
        props: {
            suffix: {
                type: String,
                default: null
            },
            isFilled: {
                type: Boolean,
                default: false
            },
            isVertical: {
                type: Boolean,
                default: false
            }
        },
    };
</script>

<style lang="scss">
.qualify-sidebar-input-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .vertical-input-container {
        display: flex;
        flex-direction: column;

        .vertical-input-item {
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .small-input {
        width: 90px;
    }

    .medium-input {
        width: 150px;
    }

    .b-radio.radio {
        .control-label {
            font-size: 18px;
            margin: 0 5px;

            @media #{$mq_phone} {
                font-size: 16px;
            }
        }
    }

    .b-checkbox.checkbox {
        align-items: flex-start;

        .control-label {
            font-size: 18px;

            @media #{$mq_phone} {
                font-size: 16px;
            }
        }
    }

    .input-suffix {
        flex: 1 1 auto;
        font-size: 18px;
        margin-left: 5px;

        @media #{$mq_phone} {
            font-size: 16px;
        }
    }

    .check-badge {
        display: inline-flex;
        flex: 0 0 25px;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        margin-left: 10px;
        font-size: 8px;
        background-color: $bluish-green;
        color: $white;
        border-radius: 50%;
        opacity: 0.2;
        transition: opacity 0.3s ease;

        &.active {
            opacity: 1;
        }

        &:after {
            @include icomoon;
            content: "\e902";
            margin-top: 2px;
        }
    }
}
</style>